<template>
  <div
    :class="{
      'ua-section-box': true,
      'ua-section-box--light': light,
      'ua-section-box--hidden': hidden
    }"
  >
    <!-- 头部 -->
    <div v-if="title && !headless" class="slidewithcenter ua-section-box__top">
      <div class="ua-section-box__title">
        {{ title }}
      </div>

      <div>
        <span v-if="toggleable" class="ua-section-box__toggle-icon pointer" @click="toggleVisible">
          <i v-if="visible" class="icon iconfont icon-a-16-1px-mins"></i>
          <i v-else class="icon iconfont icon-a-16-1px-plus"></i>
        </span>
        <slot name="action" />
      </div>
    </div>

    <!-- 锚点 -->
    <div
      v-if="name"
      :id="name"
      style="height: 0px; overflow: hidden"
      class="pdp-anchor"
      :name="name"
      :title="title"
      :short-title="shortTitle || title"
    >
      <a :href="`#${name}`">{{ title }}</a>
    </div>

    <!-- 内容区 -->
    <div v-if="$slots.default" v-show="!toggleable || visible" class="ua-section-box__content">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
import { PDP } from '../lib/mixins';

export default {
  name: 'SectionBox',
  mixins: [PDP],
  props: {
    toggleable: { type: Boolean, default: false },
    light: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    headless: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false },
    title: { type: String, default: '' },
    name: { type: String, default: '' },
    shortTitle: { type: String, default: '' }
  },
  mounted() {
    this.$nextTick(() => {
      this.visible = this.expanded;
    });
  }
};
</script>

<style lang="scss">
.ua-section-box {
  width: 100%;
  position: relative;
  background: #fff;
  overflow: hidden;

  &--light {
    border-top: 1px solid var(--line-color-line-grey-02, #eee);
    border-bottom: 1px solid var(--line-color-line-grey-02, #eee);

    .ua-section-box__title {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      padding-top: 20px;
      padding-bottom: 20px;
      margin-bottom: 0px;
    }
  }

  &--light + &--light {
    border-top: none;
  }

  + .ua-section-box {
    margin-top: 96px;
  }

  &__title {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; /* 121.429% */
    margin-bottom: 32px;
  }
}
</style>

<style lang="scss">
.page-layout_mobile .ua-section-box {
  padding-bottom: 8px;
  background: #f0f0f0;

  + .ua-section-box {
    margin-top: 0px;
  }

  &__top {
    background: #fff;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-right: 20px;
    padding-left: 20px;
  }

  &__content {
    margin-top: 0px;
    padding: 0px 20px 20px;
    background: #fff;
  }

  &__title {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 0px;
  }

  &--hidden {
    padding-bottom: 0px;
  }
}
</style>
